import styles from '../Loader/Loader.module.scss'


export const Loader = () => {
    return (
        <div className={styles.loader}></div>
    )
}
